// extracted by mini-css-extract-plugin
export var text = "_89-0";